import { GAME_FRAME } from "../../config/gameplay";
import { formatCompact } from "../../utils/math";
import type { CoreBounceImpact, OverdriveZoneHit } from "../cores/physics";
import type { PolarityMatchResult } from "../cores/polarity";
import type { UpgradeEffects } from "../upgrades/effects";
import type { CoreState } from "./types";
import type { FeedbackDraft } from "./feedback";

export function bounceImpactFeedback(
  impacts: readonly CoreBounceImpact[],
  cores: readonly CoreState[],
  effects: UpgradeEffects
): readonly FeedbackDraft[] {
  return impacts.flatMap((impact) => {
    const core = cores.find((entry) => entry.id === impact.coreId);
    const chargeText = formatCompact(effects.chargeValue);
    if (!core?.countsAsProgress || chargeText === "0") {
      return [];
    }

    return [{
      kind: "value-gain" as const,
      frameX: impact.position.x + GAME_FRAME.width / 2,
      frameY: impact.position.y + GAME_FRAME.height / 2,
      color: core.color,
      text: `+${chargeText}`
    }];
  });
}

export function polarityMatchFeedback(matches: readonly PolarityMatchResult[]): readonly FeedbackDraft[] {
  return matches.map((match) => ({
    kind: "polarity-match",
    frameX: match.position.x + GAME_FRAME.width / 2,
    frameY: match.position.y + GAME_FRAME.height / 2,
    color: match.color,
    text: match.strong ? `SYNC x${(1 + match.charge).toFixed(2)}` : `x${(1 + match.charge).toFixed(2)}`
  }));
}

export function overdriveZoneFeedback(hits: readonly OverdriveZoneHit[]): readonly FeedbackDraft[] {
  return hits.map((hit) => ({
    kind: "floating-text",
    frameX: hit.position.x + GAME_FRAME.width / 2,
    frameY: hit.position.y + GAME_FRAME.height / 2,
    color: "gold",
    text: `ZONE x${hit.multiplier}`
  }));
}
